import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { I as Icon } from '../Icon/Icon-AcXbY_t4.js';
import { f as focusOutline } from '../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { a as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { a as angleRight } from '../LocalModules/storm-ui-icons/dist/esm/classicIcons-CHpXglL2-uH6-91Kn.js';

const ExtenderButtonIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40027066__sc-1xkqa3b-0"
})(["&& > svg{@media (prefers-reduced-motion:no-preference){transition:transform 150ms ease-in-out;}", "}[dir=\"rtl\"] && > svg{@media (prefers-reduced-motion:no-preference){transition:transform 150ms ease-in-out;}/*! @noflip */ transform:rotate(180deg);", "}"], ({
  $opened
}) => $opened && css(["/*! @noflip */ transform:rotate(90deg);"]), ({
  $opened
}) => $opened && css(["/*! @noflip */ transform:rotate(90deg);"]));

// @TODO: (storm-v4) get border from tokens/theme/layer/card

const SectionExpanderContent = /*#__PURE__*/styled.section.withConfig({
  componentId: "sc-storm-ui-40027066__sc-1xkqa3b-1"
})(["background-color:", ";border-block-start:", ";font:", ";padding:", ";", ""], ({
  theme
}) => theme.surface.offset, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.spacing.base.default, isMobile(css(["font:", ";padding:", ";"], ({
  theme
}) => theme.font.text.base.mobile, ({
  theme
}) => theme.spacing.base.mobile)));
const ExtenderButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40027066__sc-1xkqa3b-2"
})(["font:", ";padding:", ";gap:", ";display:inline-flex;justify-content:space-between;width:100%;text-align:initial;cursor:pointer;margin:0px;border:none;@media (prefers-reduced-motion:no-preference){transition:", ";}color:", ";background-color:", ";:hover{background-color:", ";}:active{background-color:", ";}:focus-visible{outline:none;", " outline-offset:calc(", " + 1px);}", ""], ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.spacing.base.default, ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.sectionExpander.transition, ({
  theme
}) => theme.text.color.secondary, ({
  theme
}) => theme.button.backgroundColor.transparent.default, ({
  theme
}) => theme.button.backgroundColor.transparent.hover, ({
  theme
}) => theme.button.backgroundColor.transparent.active, focusOutline, ({
  theme
}) => theme.border.focusOffset, isMobile(css(["font:", ";padding:", ";gap:", ";"], ({
  theme
}) => theme.font.text.base.mobile, ({
  theme
}) => theme.spacing.base.mobile, ({
  theme
}) => theme.spacing.xxsmall.mobile)));
const TextButtonLabel = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-1xkqa3b-3"
})(["flex:1 1 auto;"]);
const SectionExpanderWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-1xkqa3b-4"
})(["background-color:", ";border:", ";box-shadow:", ";:not(:nth-child(1 of &)){border-block-start:none;}:nth-child(1 of &){border-start-start-radius:", ";border-start-end-radius:", ";& > :first-child{border-start-start-radius:", ";border-start-end-radius:", ";}}:nth-last-child(1 of &){border-end-start-radius:", ";border-end-end-radius:", ";& > :last-child{border-end-start-radius:", ";border-end-end-radius:", ";}}"], ({
  theme
}) => theme.surface.default, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.elevation.shadow.card, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large);
const SectionExpander = ({
  children,
  label,
  isOpen,
  handleClick,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('section-expander')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(SectionExpanderWrapper, rest, /*#__PURE__*/React__default.createElement(ExtenderButton, _extends({}, getDataTaktAttributes({
  taktIdSuffix: 'extender-button'
}), {
  tabIndex: 0,
  "aria-expanded": isOpen,
  onClick: handleClick
}), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ExtenderButtonIcon, {
  type: angleRight,
  size: "small",
  $opened: isOpen
})), /*#__PURE__*/React__default.createElement(TextButtonLabel, null, label)), isOpen && /*#__PURE__*/React__default.createElement(SectionExpanderContent, null, children)));

export { SectionExpander as S };
//# sourceMappingURL=SectionExpander-CpNoeB_D.js.map
